import { useCallback, useEffect, useState } from 'react'
import { listBookmarks } from '../services/bookmarks'

// Resolve a bookmark's item id whether `item` is populated ({ _id, ... }) or a
// bare id.
const itemIdOf = (bookmark) => bookmark && (bookmark.item?._id || bookmark.item)

// Loads the current user's bookmarks and indexes them by item id, so the Library
// nav can show which rows are bookmarked and hand the matching bookmark to the
// edit modal. Creating/removing bookmarks happens in the modals; callers
// `reload()` afterwards to refresh the indicators.
export function useBookmarks() {
  const [byItem, setByItem] = useState({}) // itemId -> bookmark
  const [status, setStatus] = useState('loading') // loading|ready|error

  const load = useCallback(() => {
    let alive = true
    setStatus('loading')
    listBookmarks()
      .then((list) => {
        if (!alive) return
        const map = {}
        list.forEach((b) => {
          const id = itemIdOf(b)
          if (id) map[id] = b
        })
        setByItem(map)
        setStatus('ready')
      })
      .catch(() => {
        if (alive) setStatus('error')
      })
    return () => {
      alive = false
    }
  }, [])

  useEffect(() => load(), [load])

  const isBookmarked = useCallback((itemId) => Boolean(byItem[itemId]), [byItem])
  const getBookmark = useCallback((itemId) => byItem[itemId] || null, [byItem])

  return { byItem, status, isBookmarked, getBookmark, reload: load }
}
